import VueBaseController from '../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() {
    return () => import('@/vue/pages/admin/orders_analytics/index.vue')
  }
}